module.exports = __webpack_public_path__ + "static/media/salvador-ba.68ceb7ea.jpg";